import { useEffect } from 'react';
import { isFunction } from '@src/utils/type-utils';
import { noop } from '@src/utils/common-util';

/**
 * 等效于 component did mount
 * @param callback
 */
const useMount = callback => {
  // noinspection JSCheckFunctionSignatures
  useEffect(() => {
    let result = callback();
    if (!isFunction(result)) {
      result = noop;
    }
    return result;
    // eslint-disable-next-line
  }, []);
};

export default useMount;
